"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    outline: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const outline = {
    className: 'otln',
    cssName: 'outline',
    jsName: 'outline',
    complexValue: true
};
exports.propEnhancers = {
    outline: (value) => get_css_1.default(outline, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3V0bGluZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvb3V0bGluZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDREQUFrQztBQUNsQyx5REFBK0I7QUFHbEIsUUFBQSxTQUFTLEdBQXFCO0lBQ3pDLE9BQU8sRUFBRSxvQkFBUyxDQUFDLE1BQU07Q0FDMUIsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFHLEVBQUUsQ0FBQTtBQUVoQixRQUFBLGNBQWMsR0FBbUIsRUFBRyxDQUFBO0FBRWpELE1BQU0sT0FBTyxHQUFHO0lBQ2QsU0FBUyxFQUFFLE1BQU07SUFDakIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsTUFBTSxFQUFFLFNBQVM7SUFDakIsWUFBWSxFQUFFLElBQUk7Q0FDbkIsQ0FBQTtBQUVZLFFBQUEsYUFBYSxHQUFrQjtJQUMxQyxPQUFPLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUM7Q0FDbEUsQ0FBQSJ9